/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, Injector, OnChanges } from '@angular/core';
import { PoDynamicViewField } from '@po-ui/ng-components';
import { clone } from 'ramda';
import { BaseCustomFields } from '../base-custom-fields';

@Component({
  selector: 'tgv-custom-fields-view',
  standalone: false,
  templateUrl: './custom-fields-view.component.html'
})

export class CustomFieldsViewComponent extends BaseCustomFields implements OnChanges {
  presentationValue;
  override fields: PoDynamicViewField[] = [];
  constructor(
    protected override injector: Injector
  ) {
    super(injector);
  }

  ngOnChanges() {
    if (this.fields) {
      this.presentationValue = clone(this.fieldsValues);
      this.setPresentationFields();
    }
  }

  setPresentationFields(): void {
    this.fields.forEach(f => {
      if (f.type == 'Date') {
        if (this.fieldsValues[f.property]) {
          this.presentationValue[f.property] = this.formatFilterDate(this.fieldsValues[f.property]);
        }
      }
      if (f.options) {
        if (this.fieldsValues[f.property]) {
          const pos = f.options.findIndex(x => x.value === this.fieldsValues[f.property]);
          this.presentationValue[f.property] = `${f.options[pos].value} - ${f.options[pos].label}`;
        }
      }
    });
  }

  formatFilterDate(date: string): string {
    return this.datePipe.transform(date, 'dd/MM/yyyy');
  }
}


